<div class="modal-header">
  <h4 class="modal-title">Промяна на метода на потвърждение</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <fieldset class="mb-4">
      <div class="form-check">
        <input
          id="confirmation-method-password"
          type="radio"
          class="form-check-input"
          formControlName="confirmationMethod"
          [value]="UserConfirmationMethod.Password">
        <label for="confirmation-method-password" class="form-check-label">Чрез парола</label>
      </div>
      <span class="small text-muted">
        При потвърждение на покупка или наддаване ще се изисква въвеждане на вашата парола.
      </span>
      <span class="small text-success">Препоръчително!</span>
    </fieldset>
    <fieldset class="mb-4">
      <div class="form-check">
        <input
          id="confirmation-method-pin"
          type="radio"
          class="form-check-input"
          formControlName="confirmationMethod"
          [value]="UserConfirmationMethod.Pin">
        <label for="confirmation-method-pin" class="form-check-label">Чрез ПИН код</label>
      </div>
      <span class="small text-muted">
        При потвърждение на покупка или наддаване ще се изисква въвеждане на вашия ПИН.
      </span>
      <span class="small text-success">Препоръчително!</span>
      @if (confirmationMethod?.value === UserConfirmationMethod.Pin) {
        <fieldset class="mt-2">
          <input
            id="pin"
            type="password"
            formControlName="pin"
            class="form-control"
            placeholder="Въведете ПИН..."
            aria-label="ПИН"
            [class.is-valid]="pin?.touched && pin?.valid"
            [class.is-invalid]="pin?.touched && pin?.invalid">
          <p class="invalid-feedback m-0">Задължително поле!</p>
        </fieldset>
      }
    </fieldset>
    <fieldset class="mb-4">
      <div class="form-check">
        <input
          id="confirmation-method-none"
          type="radio"
          class="form-check-input"
          formControlName="confirmationMethod"
          [value]="UserConfirmationMethod.None">
        <label for="confirmation-method-none" class="form-check-label">Без въвеждане на парола или ПИН</label>
      </div>
      <span class="small text-muted">
        При потвърждение на покупка или наддаване няма да се изисква въвеждане на вашата парола или ПИН.
      </span>
      <span class="small text-danger">Не е препоръчително!</span>
    </fieldset>
    <fieldset class="mb-4">
      <label for="password" class="mb-0 form-label">Парола*</label>
      <input
        id="password"
        type="password"
        formControlName="password"
        class="form-control"
        placeholder="Въведете парола..."
        aria-label="Парола"
        [class.is-valid]="password?.touched && password?.valid"
        [class.is-invalid]="password?.touched && password?.invalid">
      <p class="invalid-feedback m-0">Задължително поле!</p>
    </fieldset>
  </form>
  @if (!!errorMessage) {
    <div class="pb-2 text-danger">
      {{ errorMessage }}
    </div>
  }
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Запази</span>
  </button>
</div>
